export const messages = {
  onClearMatchResult: '!Los resultados se borraron correctamente!',
  onError: '!Ha ocurrido un error!',
  onMatchUpdated: '!Encuentro actualizado con éxito!',
  onMatchCanceled: '!Encuentro cancelado con éxito!',
  onMatchScheduled: '!Encuentro programado con éxito!',
};
